import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function InfoNotificationView
 * @param {STRING} className - Sets a unique className for the component.
 * @param {STRING} text - Sets the info text for the component.
 * @param {STRING} textClass - Sets the className for the text.
 * @exported true
 * @returns {React.Component}
 * @description - This is the main component for all info notifications in RXP22. It has gray text, a white background, with a blue icon.
 * @example
 * <InfoNotificationView className="my-info-notification" text="This is my text" />
 */
export default function InfoNotificationView(props) {
  const className = props.className ?? "";
  // Any biller name or page name will need the bold-text className applied
  const text = props.text ?? "[text]";
  const textClass = props.textClass ?? "gray-text";
  const icon = props.icon ?? "UpsellIcon";

  return(
    <div className={"info-notification-view flex-container flex-horizontal align-center " + className}>
      <SVGAsset id={icon} className="set-width left-icon blue-icon" />
      <span className={"flex-width " + textClass}>{ text }</span>
    </div>
  );
}